jQuery( function ( $ ) {
	function show_filter_fields() {
		$( '.wpas-field' ).removeClass( 'hidden' );
	}

	function hide_filter_fields() {
		$( '.wpas-field' ).each( function () {
			if ( $( 'input[type="text"]', this ).length ) {
				return;
			}

			if ( $( 'button', this ).length ) {
				$( this ).addClass( 'block md:hidden' );
				return;
			}

			$( this ).addClass( 'hidden md:block' );
		} );
	}

	$( '.filter-toggle-button' ).on( 'click', function () {
		if ( $( this ).hasClass( 'button-open' ) ) {
			$( this ).removeClass( 'button-open' );
			hide_filter_fields();
			return;

		}

		$( this ).addClass( 'button-open' );
		show_filter_fields();
	} );

	hide_filter_fields();

	// Tick checkbox by default if only one is available.
	$( '.wpas-checkboxes > ul' ).each( function () {
		// Show or hide child checkboxes.
		$( this ).find( '.wpas-checkbox' ).on( 'change update', function () {
			let children = $( this ).closest( 'li' ).next( 'ul' );

			if ( this.checked ) {
				children.show();
				return;
			}

			children.find( '.wpas-checkbox' ).prop( 'checked', false );
			children.hide();
		} );

		let parents = $( this ).find( '> li' );

		// Show child checkboxes if only one parent checkbox is available.
		if ( 1 === parents.length ) {
			parents.hide();
			parents.next( 'ul' ).css( 'padding-left', 0 );
		}
	} );

	$( '.wpas-checkboxes .wpas-checkbox' ).each( function () {
		// Add data-value attribute to all checkboxes.
		$( this ).data( 'value', $( this ).val() );

		// Exclude parent checkbox if any of children is checked.
		$( this ).on( 'click', function () {
			let parent = $( this ).closest( 'li' ).parent().prev( 'li' ).find( 'input:checkbox' );

			if ( ! parent ) {
				return;
			}

			// Uncheck parent if any of children is checked.
			if ( $( this ).closest( 'li' ).parent().find( 'input:checkbox' ).is( ':checked' ) ) {
				parent.val( '' );
				return;
			}

			parent.val( parent.data( 'value' ) );
		} );

		// Trigger showing and hiding child checkboxes depending on checked parents.
		// Use a custom 'update' event to avoid triggering the function more than once.
		$( this ).trigger( 'update' );
	} );
} );
